module.exports = {"TXTWCL_SorryX_you_must_verify_your_id_ELL":{"id":"TXTWCL_SorryX_you_must_verify_your_id_ELL","defaultMessage":"很抱歉，您必須使用MitID驗證您的身分才能繼續。"}}